import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { OAuth2CallbackPage } from '~/components/Credentials/OAuth2AuthCode/OAuth2CallbackURL.tsx';

const searchSchema = z.object({
  state: z.string().min(1),
});

/**
 * The path here is fixed by the redirect_uri already registered with OAuth 2.0 providers
 * (`/connections/oauth2/callback`), so it does not follow the `callback.<provider>` naming used by
 * the OAuth1 and Git routes.
 */
export const Route = createFileRoute('/connections/oauth2/callback')({
  component: RouteComponent,
  validateSearch: searchSchema,
  search: {
    middlewares: [
      ({ search, next }) => {
        const result = next(search);

        return {
          ...result,
          state: search.state,
        };
      },
    ],
  },
});

function RouteComponent() {
  const params = Route.useSearch();

  return <OAuth2CallbackPage state={params.state} />;
}
